<template>
  <div class="loader-container" :class="{ 'loader-opaque': isSubmitLoading }">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    isSubmitLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);
  z-index: 9999;
}

.loader-opaque {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
